var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAK0lEQVR42mNgGAng/38IpkgzWQYgaybZAHTNA+OFIW4AtkAkySCKDRhKAAB8jU+x6ZwbNAAAAABJRU5ErkJggg==";
  export default img;